import React, { useState } from 'react';
import { InfoIcon, ChevronDownIcon } from 'lucide-react';
/**
 * Collapsible archived/legacy models accordion.
 * Owns its own expanded/collapsed state — not shared.
 */
export function LegacyAccordion() {
  const [open, setOpen] = useState(false);
  return <div className="border border-gray-200 rounded-xl overflow-hidden bg-white" data-id="element-299">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between p-6 bg-gray-50 hover:bg-gray-100 transition-colors text-left" data-id="element-300">
        <div className="flex items-center gap-3" data-id="element-301">
          <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-500" data-id="element-302">
            <InfoIcon className="w-4 h-4" data-id="element-303" />
          </div>
          <div data-id="element-304">
            <h3 className="font-bold text-gray-700" data-id="element-305">Archived Legacy Models</h3>
            <p className="text-sm text-gray-500 font-normal" data-id="element-306">
              Information on discontinued Gen 1 / early Gen 2 variations
            </p>
          </div>
        </div>
        <ChevronDownIcon className={`w-5 h-5 text-gray-400 transition-transform duration-300 ${open ? 'rotate-180' : ''}`} data-id="element-307" />
      </button>

      {open && <div className="p-6 border-t border-gray-200 text-sm text-gray-600 leading-relaxed bg-white" data-id="element-308">
          <p className="mb-4" data-id="element-309">
            Historically, Daedo produced several variations of footgear
            primarily for the Gen 1 system, which are now largely obsolete in
            modern competition:
          </p>
          <ul className="space-y-3 list-disc pl-5 mb-4" data-id="element-310">
            <li data-id="element-311">
              <strong className="text-gray-800" data-id="element-312">E-Foot G4 (Grey):</strong> The
              standard 6-sensor sock used primarily with Gen 1 Hogus.
            </li>
            <li data-id="element-313">
              <strong className="text-gray-800" data-id="element-314">E-Heel:</strong> A single-sensor
              detachable heel piece used when E-Headgear was implemented in
              higher-ranking divisions.
            </li>
            <li data-id="element-315">
              <strong className="text-gray-800" data-id="element-316">E-Foot Complete:</strong> A rare
              7-sensor all-in-one piece that combined the standard footgear with
              the heel sensor.
            </li>
          </ul>
          <p className="text-gray-500 italic" data-id="element-317">
            Note: The Gen 2 PSS (introduced for the 2016 Rio Olympics)
            standardized the 11-sensor Gen 2 E-Footgear, replacing the need for
            these fragmented variations in elite competition.
          </p>
        </div>}
    </div>;
}